module.exports = __webpack_public_path__ + "img/14.10.pH.de553537.png";